import { Button } from 'components/shared/Button';
import styled from 'styled-components';
import { container, fontSize, fontWeight, screen, spacing } from '../../theme';

export const StyledPath = styled.section`
  text-align: center;
  margin-bottom: ${spacing('xl6')};
`;

export const StyledIntro = styled.div`
  max-width: ${container('lg')};
  margin: 0 auto ${spacing('xl4')};
  line-height: 1.5;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;

    a {
      font-weight: ${fontWeight('bold')};
    }
  }

  ${Button} {
    margin-top: ${spacing('md')};
  }
`;

export const StyledLevels = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing('md')};
  margin-top: ${spacing('lg')};
  margin-bottom: ${spacing('md')};

  @media (min-width: ${screen('lg')}) {
    grid-template-columns: 1fr 1fr 1fr;
    margin-bottom: ${spacing('xl3')};
  }
`;
